module.exports = __webpack_public_path__ + "static/media/testbg.ec47746e.png";